// Pure helpers for the Shared links page: link state, expiry choices and the summary numbers.
export const TYPES = [{ id: 'scan', label: 'Scan' }, { id: 'finding', label: 'Finding' }, { id: 'case', label: 'Case' }];
export const EXPIRY = [{ id: 1, label: '1 day' }, { id: 7, label: '7 days' }, { id: 30, label: '30 days' }, { id: 0, label: 'No end' }];

export const stateOf = (l, now = new Date()) => (l.revoked_at ? 'withdrawn' : l.expires_at && new Date(l.expires_at) <= now ? 'expired' : 'active');
export const STATE = { active: { label: 'Active', color: '#22c55e' }, expired: { label: 'Expired', color: '#94a3b8' }, withdrawn: { label: 'Withdrawn', color: '#ef4444' } };

export const expiryAt = (days, now = new Date()) => (days ? new Date(now.getTime() + days * 86400000).toISOString() : null);

export function expiryText(l, now = new Date()) {
  const st = stateOf(l, now);
  if (st === 'withdrawn') return 'Withdrawn';
  if (!l.expires_at) return 'Never expires';
  const days = Math.ceil((new Date(l.expires_at) - now) / 86400000);
  if (st === 'expired') return 'Expired';
  return days <= 1 ? 'Expires within a day' : `Expires in ${days} days`;
}

export function summary(links, now = new Date()) {
  const active = links.filter((l) => stateOf(l, now) === 'active');
  return {
    active: active.length,
    views: links.reduce((n, l) => n + (l.access_count || 0), 0),
    soon: active.filter((l) => l.expires_at && new Date(l.expires_at) - now <= 7 * 86400000).length
  };
}

export const viewsText = (n) => `${n || 0} view${n === 1 ? '' : 's'}`;
